import { render, staticRenderFns } from "./SendSmsDialog.vue?vue&type=template&id=3074e1b0&scoped=true&"
import script from "./SendSmsDialog.vue?vue&type=script&lang=js&"
export * from "./SendSmsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsDialog.vue?vue&type=style&index=0&id=3074e1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3074e1b0",
  null
  
)

export default component.exports